// VPN detection removed.
export const useVPNDetection = () => ({
  isVPN: false,
  isBlocked: false,
  isLoading: false,
  error: null as any,
  recheckVPN: () => {},
});
